import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { App } from "./App";
import "./styles/main.css";

// Vite bakes import.meta.env values at build time, so VITE_SENTRY_DSN
// must be set in Render's static-site env vars (not at runtime). Empty
// string → no init → @sentry/react becomes a no-op for the session.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0, // exception capture only
    sendDefaultPii: false,
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
